import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  id: 'B1',
  title: 'Fichero Imprimible — Primer Grado',
  desc: '30 fichas de actividades listas para fotocopiar y entregar. Mapas de logros, juegos recortables y diploma de mérito incluidos.'
}, {
  id: 'B2',
  title: 'Fichero Imprimible — Segundo Grado',
  desc: '30 fichas alineadas al sistema posicional hasta 1.000 y la introducción a la multiplicación. Listo para entregar el lunes.'
}, {
  id: 'B3',
  title: 'Fichero Imprimible — Tercer Grado',
  desc: '30 fichas para trabajar las tablas de multiplicar, la división y las fracciones iniciales. Con bingo recortable y diploma de científico.'
}, {
  id: 'B4',
  title: 'Fichero Imprimible — Cuarto Grado',
  desc: '30 fichas del Club de las Fracciones. Dominó de fracciones, pizzas recortables y desafío final del maestro del club.'
}, {
  id: 'B5',
  title: 'Fichero Imprimible — Quinto Grado',
  desc: '30 fichas de proporciones, porcentajes y el círculo. Con tiras de fracciones recortables y el gran desafío de la Academia.'
}, {
  id: 'B6',
  title: 'Fichero Imprimible — Sexto Grado',
  desc: '30 fichas del Camino al Secundario. Potencias, enteros, ecuaciones, probabilidad y la carta al secundario para cerrar el ciclo primario con emoción.'
}];
export const Bonuses = () => {
  return <section className="py-20 bg-brand-green text-white relative overflow-hidden" data-id="element-16">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-10" data-id="element-17">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-brand-gold rounded-full blur-3xl" data-id="element-18"></div>
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-brand-orange rounded-full blur-3xl" data-id="element-19"></div>
      </div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-20">
        <div className="text-center mb-16" data-id="element-21">
          <div className="inline-flex items-center gap-2 bg-brand-gold text-white font-bold px-4 py-1.5 rounded-full text-sm mb-6" data-id="element-22">
            <Gift size={16} data-id="element-23" /> INCLUIDOS GRATIS
          </div>
          <h2 className="text-3xl md:text-4xl font-heading font-bold mb-4" data-id="element-24">
            6 Bonos que Resuelven el Trabajo del Alumno
          </h2>
          <p className="text-xl text-cream/90" data-id="element-25">
            Sin costo extra — incluidos en todas las ofertas
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-26">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} className="bg-white text-gray-900 rounded-2xl p-6 shadow-lg border-t-4 border-brand-gold relative" data-id="element-27">
              <div className="absolute -top-4 right-6 bg-brand-orange text-white text-xs font-bold px-3 py-1 rounded-full shadow-sm" data-id="element-28">
                GRATIS
              </div>
              <div className="text-brand-gold font-heading font-extrabold text-3xl mb-2 opacity-30" data-id="element-29">
                {bonus.id}
              </div>
              <h3 className="font-bold text-lg mb-3 leading-tight" data-id="element-30">
                {bonus.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-31">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>

        <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-8 text-center max-w-3xl mx-auto" data-id="element-32">
          <h3 className="text-2xl md:text-3xl font-heading font-bold" data-id="element-33">
            VALOR TOTAL:{' '}
            <span className="line-through text-white/50" data-id="element-34">$56.000</span>{' '}
            <span className="text-brand-gold" data-id="element-35">— GRATIS</span>
          </h3>
        </div>
      </div>
    </section>;
};